var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help"},[_c('public1'),_c('div',{staticClass:"help-content right-content"},[_c('div',{staticClass:"perheader"},[_c('perheader')],1),_c('div',{staticClass:"table-content"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }